import { render, staticRenderFns } from "./sp-city.vue?vue&type=template&id=0c928916&scoped=true"
import script from "./sp-city.vue?vue&type=script&lang=js"
export * from "./sp-city.vue?vue&type=script&lang=js"
import style0 from "./sp-city.vue?vue&type=style&index=0&id=0c928916&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c928916",
  null
  
)

export default component.exports